import { render, staticRenderFns } from "./OrdersTableHeaderActions.vue?vue&type=template&id=5bbb69ba&scoped=true&"
import script from "./OrdersTableHeaderActions.vue?vue&type=script&lang=js&"
export * from "./OrdersTableHeaderActions.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTableHeaderActions.vue?vue&type=style&index=0&id=5bbb69ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb69ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bbb69ba')) {
      api.createRecord('5bbb69ba', component.options)
    } else {
      api.reload('5bbb69ba', component.options)
    }
    module.hot.accept("./OrdersTableHeaderActions.vue?vue&type=template&id=5bbb69ba&scoped=true&", function () {
      api.rerender('5bbb69ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/OrdersTableHeaderActions.vue"
export default component.exports